import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import API from "../services/api";

const POLL_INTERVAL_MS = 60 * 1000;

function getErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  return fallback;
}

function CheckInReminderBanner() {
  const location = useLocation();
  const [needsCheckIn, setNeedsCheckIn] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    try {
      const res = await API.get("/attendance/me/today");
      setNeedsCheckIn(!!res.data?.needs_checkin);
    } catch {
      // Quiet no-op - a failed background poll shouldn't surface an error
      // banner of its own on every other page in the app.
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [refresh]);

  // The Attendance page already shows its own check-in reminder inline.
  if (location.pathname.startsWith("/attendance")) return null;
  if (!needsCheckIn) return null;

  const checkIn = async () => {
    setSubmitting(true);
    setError("");
    try {
      await API.post("/attendance/check-in");
      setNeedsCheckIn(false);
    } catch (e) {
      setError(getErrorMessage(e, "Unable to check in"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="alert alert-warning d-flex justify-content-between align-items-center mb-0 rounded-0" role="alert">
      <span>{error || "You haven't checked in today."}</span>
      <button type="button" className="btn btn-sm btn-primary" disabled={submitting} onClick={checkIn}>
        {submitting ? "Checking in..." : "Check In Now"}
      </button>
    </div>
  );
}

export default CheckInReminderBanner;
